import * as z from "zod";
import {VisitHistoryDetailResModel} from "./VisitHistoryDetailResModel";

const schema = z.object({
	list: z.array(VisitHistoryDetailResModel.model).default([])
});

const model = schema.transform((values) => ({
	...values
}));

export const TaxAccountVisitHistoryListResModel = {schema, model};
export type ITaxAccountVisitHistoryListResModel = z.infer<typeof TaxAccountVisitHistoryListResModel.model>;
export const DEFAULT_TAX_ACCOUNTANT_VISIT_HISTORY_LIST_RES: ITaxAccountVisitHistoryListResModel = {
	list: []
};
